// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1tzki","selected":"Chip_selected__1Yu4J"};